<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: 'main',
    },
  },
}
</script>

<template>
  <button
    type="button"
    :class="`btn btn-${type} input`"
    :disabled="loading"
    @click="$emit('click')"
  >
    <font-awesome-icon
      v-if="loading"
      :icon="['fas', 'spinner']"
      class="mr-1"
      spin
    />
    <slot v-else />
  </button>
</template>
